<script lang="ts">
	import { format } from 'svelte-i18n';
	import { createEventDispatcher } from 'svelte';

	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	import { Button, ButtonV2, Checkbox, Container, Modal, Text } from '@Shelly/shelly-design-system';

	import { capFirstChar } from 'src/helpers/utilities';

	export let showModal = false;
	export let homeName = '';
	export let loading = false;

	const dispatch = createEventDispatcher<{ confirm: void }>();

	let homeConsentCheck = false;

	$: if (!showModal) {
		homeConsentCheck = false;
	}

	$: consentLabel = $format('unit_transfer_home_consent', {
		default: 'I consent to receive the home: "{name}"',
		values: { name: homeName },
	});

	function onClose(): void {
		if (loading) return;
		showModal = false;
	}

	function onConfirm(): void {
		if (!homeConsentCheck || loading) return;
		dispatch('confirm');
	}
</script>

<Modal
	{showModal}
	on:close={onClose}
	title={capFirstChar(
		$format('unit_transfer_accept_consent_title', { default: 'Accept home transfer' }),
	)}
	removeScrollPadding
>
	<svelte:fragment slot="content">
		<Container padding="scrollPaddings">
			<Text class="mb-m">
				{$format('unit_transfer_accept_consent_message', {
					default:
						"By accepting, you'll become the owner of this home, along with its devices, automations, and data.",
				})}
			</Text>
			<Checkbox
				id="pending-unit-transfer-home-consent"
				size="m"
				bind:checked={homeConsentCheck}
				disabled={loading}
				aria-label={consentLabel}
			>
				{consentLabel}
			</Checkbox>
		</Container>
	</svelte:fragment>

	<div slot="footer" class="d-flex justify-content-end">
		{#if $showNewLayout}
			<ButtonV2
				size="l"
				variant="secondary"
				class="mr-s"
				disabled={loading}
				aria-label={$format('button_cancel', { default: 'Cancel' })}
				on:click={onClose}
			>
				{$format('button_cancel', { default: 'Cancel' })}
			</ButtonV2>
			<ButtonV2
				size="l"
				variant="primary"
				disabled={!homeConsentCheck}
				{loading}
				aria-label={$format('button_accept', { default: 'Accept' })}
				on:click={onConfirm}
			>
				{$format('button_accept', { default: 'Accept' })}
			</ButtonV2>
		{:else}
			<Button
				variant="secondary"
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
				responsiveSize={{ sm: 'm' }}
				disabled={loading}
				aria-label={$format('button_cancel', { default: 'Cancel' })}
				on:click={onClose}
			>
				{$format('button_cancel', { default: 'Cancel' })}
			</Button>
			<Button
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
				responsiveSize={{ sm: 'm' }}
				disabled={!homeConsentCheck}
				{loading}
				aria-label={$format('button_accept', { default: 'Accept' })}
				on:click={onConfirm}
			>
				{$format('button_accept', { default: 'Accept' })}
			</Button>
		{/if}
	</div>
</Modal>
